module.exports = __webpack_public_path__ + "7d2e29ab647c6bd5a637341d53f0b49c.MP3";